<!-- 底部版权协议 -->
<template>
  <div class="agreement">
    <!-- 底部版权协议 -->
    <el-form ref="form" label-width="100px">
      <!-- <el-form-item label="版权">
        <el-input v-model="configform.copyright"></el-input>
      </el-form-item>
      <el-form-item label="ICP">
        <el-input v-model="configform.icp"></el-input>
      </el-form-item>
      <el-form-item label="ICP链接">
        <el-input v-model="configform.icp_link"></el-input>
      </el-form-item>
      <el-form-item label="公安备案">
        <el-input v-model="configform.public_security"></el-input>
      </el-form-item>
      <el-form-item label="公安备案链接">
        <el-input v-model="configform.public_security_links"></el-input>
      </el-form-item> -->
      <el-form-item label="用户条款">
        <quill-editor v-model="configform.user_protocol" :options="editorOption" @change="onEditorChange($event)" />
      </el-form-item>
      <el-form-item label="隐私政策">
        <!-- <el-input type="textarea" v-model="configform.privacy_agreement"></el-input> -->
        <quill-editor v-model="configform.privacy_agreement" :options="editorOption" @change="onEditorChangeTwo($event)" />
      </el-form-item>
      <el-form-item label="积分领取协议">
        <!-- <el-input type="textarea" v-model="configform.privacy_agreement"></el-input> -->
        <quill-editor v-model="configform.points_agreement" :options="editorOption" @change="onEditorChangeTree($event)" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">提交</el-button>
        <el-button>取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import { configinfo, configedit } from "../../api/system.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    quillEditor
  },
  data() {
    //这里存放数据
    return {
      configform: {},
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], //加粗，斜体，下划线，删除线
            ["blockquote", "code-block"], //引用，代码块
            [{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
            [{ list: "ordered" }, { list: "bullet" }], //列表
            [{ indent: "-1" }, { indent: "+1" }], // 缩进
            [{ color: [] }], // 字体颜色，字体背景颜色
            ["link","image"] //上传图片、上传视频
          ]
        },

        theme: "snow"
      }
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //查询信息
    condata() {
      configinfo({
        currency_id:parseInt(localStorage.getItem('countryId'))
      }).then(res => {
        // console.log(res);
        if (res.status_code == 200) {
          this.configform = res.data;
        }
      });
    },
    //编辑版权协议
    onSubmit() {
      // console.log(this.configform);
      let data = {
        copyright: this.configform.copyright,
        icp: this.configform.icp,
        icp_link: this.configform.icp_link,
        public_security: this.configform.public_security,
        public_security_links: this.configform.public_security_links,
        privacy_agreement: this.configform.privacy_agreement,
        user_protocol: this.configform.user_protocol,
        points_agreement: this.configform.points_agreement,
        currency_id:parseInt(localStorage.getItem('countryId'))
      };
      configedit(data).then(res => {
        // console.log(res);
        if (res.status_code == 200) {
          this.condata();
          this.$message({
            type: "success",
            message: "编辑成功!"
          });
        }
      });
    },
    //用户协议
    onEditorChange({ quill, html, text }) {
      // // console.log("quill", quill);
      // // console.log("html", html);
      // console.log("text", text);
      // this.configform.user_protocol=text
      // this.content = html;
    },
    //隐私政策
    onEditorChangeTwo({ quill, html, text }) {
      // // console.log("quill", quill);
      // // console.log("html", html);
      // console.log("text", text);
      // this.configform.privacy_agreement=text
      // this.content = html;
    },
    //积分领取协议
    onEditorChangeTree({ quill, html, text }) {
      // // console.log("quill", quill);
      // // console.log("html", html);
      // console.log("text", text);
      // this.configform.privacy_agreement=text
      // this.content = html;
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.condata();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.agreement {
  padding: 20px 30px 0;
}
</style>
<style  lang='scss'>
.ql-container {
  height: 300px;
}
</style>